module.exports = __webpack_public_path__ + "static/img/04.bd7d4ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/04.png
// module id = RcP+
// module chunks = 1